import React from "react";
import NewsletterTwentyThree from "../component/NewsletterTwentyThree";

function NewsletterTwentyThreeContainer() {
  return <NewsletterTwentyThree />;
}

export default NewsletterTwentyThreeContainer;
